import React, { Component } from 'react';
import '../../content/css/ContractReviewer.css';
import HighlightExportTextBox from './HighlightExportTextBox';

const HIGHLIGHT_SECTIONS = { GUIDANCE: 0, EXAMPLES: 1, EXPLANATION: 2, APPROVAL: 3, NOTES: 4 };

export default class HighlightExportTexts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            highlights: []
        };
    }

    componentDidMount() {
        if (this.props.highlights.length !== 0) this.initializeHighlights(this.props.highlights);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.highlights !== prevProps.highlights) {
            this.initializeHighlights(this.props.highlights);
        }
    }

    initializeHighlights(highlights) {
        let transformedHighlights = highlights.map(x => ({ ...x, shouldExport: true, visibleSections: Object.values(HIGHLIGHT_SECTIONS) }));
        this.setState({ highlights: transformedHighlights });
    }

    getTextBoxes() {
        return this.state.highlights.map((h, i) => (
            <HighlightExportTextBox
                index={i}
                highlight={h}
                highlightsCount={this.state.highlights.length}
                visibleSections={this.props.visibleSections}
                isAdmin={this.props.isAdmin}
            />
        ));
    }

    render() {
        return (
            <div className="export-texts">
                <div className="clause-info-list">
                    {this.getTextBoxes()}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Highlight/HighlightExportTexts.js